import { Component } from '@angular/core';
import { MachineSaleShopService } from '../../../services/machines/machine-sale.service';
import { ConfigurationService } from '../../../services/configuration/configuration.service';
import { StoreHistoryService } from 'src/app/services/store-history.service';
import { DispatcherService } from 'src/app/services/dispatcher.service';
import { CustomShopInformation } from 'src/app/lib/custom-shop/custom-shop.information';

@Component({
  selector: 'app-return-card',
  templateUrl: './return-card.component.html',
  styleUrls: ['./return-card.component.css'],
})
export class ReturnCardButtonComponent {
  constructor(
    private dispatcherService: DispatcherService,
    private configurationService: ConfigurationService,
    private machineSaleShopService: MachineSaleShopService,
    private storeHistoryService: StoreHistoryService,
  ) {
  }

  get visible(): boolean {
    const state = this.machineSaleShopService.state;
    return state && state === 'idle'
      && this.storeHistoryService.isEmpty
      && this.configurationService?.configuration?.originalConfigurationHelper?.getBoolean('return_card');
  }

  onClick(): void {
    this.dispatcherService.onButtonCustomSaleShopClick(
      new CustomShopInformation('/card-dispenser-return-card', '/card-dispenser-return-card/restore'));
  }
}
